var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icon/Unfilled/cloud-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M38.9992 76.8C29.7208 76.8 22.1992 69.2784 22.1992 60C22.1992 51.9904 27.8044 45.2899 35.3062 43.6072C34.9743 42.1246 34.7992 40.5827 34.7992 39C34.7992 27.402 44.2012 18 55.7992 18C65.9603 18 74.4358 25.2167 76.38 34.8041C76.5194 34.8014 76.6591 34.8 76.7992 34.8C88.3972 34.8 97.7992 44.202 97.7992 55.8C97.7992 65.9596 90.5846 74.4342 80.9992 76.3799M72.5992 64.2L59.9992 51.6M59.9992 51.6L47.3992 64.2M59.9992 51.6L59.9992 102",
    stroke: "#5B6161",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadLarge);
export default __webpack_public_path__ + "static/media/cloud-upload-large.c710db11e5a78eb51d7434bfc5e5fe9c.svg";
export { ForwardRef as ReactComponent };